import { useTranslations } from '@vocab/react';
import { Box, Stack, Heading, Inline } from 'braid-design-system';

import { useConfig } from 'src/provider/config';

import translations from './.vocab';

import * as styles from './Banner.css';

export const Banner = () => {
  const { t } = useTranslations(translations);
  const { countryCode, absoluteUrl } = useConfig();

  const headline = absoluteUrl !== '' ? t(`${countryCode}-headline`) : ' ';
  const subheading = absoluteUrl !== '' ? t(`${countryCode}-subheading`) : ' ';

  return (
    <Box display="flex" justifyContent="center">
      <Box
        background="brand"
        borderRadius="standard"
        paddingY={{
          desktop: 'xlarge',
        }}
        paddingX={{
          desktop: 'xlarge',
        }}
        id="top-banner"
        className={styles.BannerFormatting}
      >
        <Box
          paddingY={{
            desktop: 'large',
          }}
        >
          <Stack space="small">
            <Heading
              align={{
                mobile: 'left',
                tablet: 'left',
              }}
              level="1"
              weight="regular"
              id="community-banner-heading"
            >
              {headline}
            </Heading>
            <Inline
              align={{
                mobile: 'left',
                tablet: 'left',
              }}
              space="xxsmall"
            >
              <Heading
                align={{
                  mobile: 'left',
                  tablet: 'left',
                }}
                level="4"
                weight="weak"
                id="community-banner-subheading"
              >
                {subheading}
              </Heading>
            </Inline>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};
